import * as API from '@/services/api';
import { message } from 'antd';

export default {
    namespace: 'member',
    state: {
        memberList: [],
        memberInfo: [],
        memberParams: {},
        memberPagination: {},
        memberAll: []
    },
    effects: {
        *getMemberAll({ payload }, { call, put }) {
            const res = yield call(API.getMemberList, { ...payload });
            if (res.code === 0) {
                const data = res.data;
                yield put({
                    type: 'save',
                    payload: {
                        memberAll: data.data
                    }
                })
            }
        },
        *getMemberList({ payload }, { call, put, select }) {
            const params = yield select(state => state.member.memberParams);
            const res = yield call(API.getMemberList, { ...params, ...payload });
            if (res.code === 0) {
                const data = res.data;
                yield put({
                    type: 'save',
                    payload: {
                        memberList: data.data,
                        memberParams: { ...params, ...payload },
                        memberPagination: data.pagination
                    }
                })
            }
        },
        *addMember({ payload }, { call, put }) {
            const res = yield call(API.addMember, payload);
            if (res.code === 0) {
                message.success('OK');
                yield put({
                    type: 'getMemberList'
                })
            } else {
                message.error(res.message)
            }
            return res;
        },
        *editMember({ payload }, { call, put }) {
            const res = yield call(API.editMember, payload);
            if (res.code === 0) {
                message.success('OK');
                yield put({
                    type: 'getMemberList'
                })
            } else {
                message.error(res.message)
            }
            return res;
        },
    },
    reducers: {
        save(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
}
